"use client";
import React from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useSearchContext } from "@/contexts/SearchContext";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { CirclePlus, MessageCircle, Rss, Search, User2 } from "lucide-react";
import { IoMdHome } from "react-icons/io";
import useLang from "@/hooks/useLang";
import ModalSearch from "@/components/search/ModalSearch/ModalSearch";

const BottomNav = () => {
  const pathname = usePathname();
  const { getText } = useLang();
  const { openModalSearch, setOpenModalSearch } = useSearchContext();
  const isMobileXs = useMediaQuery("(max-width: 410px)");
  const pathOnQuote = pathname.startsWith("/quote");
  const pathOnMessage = pathname.includes("/inbox");
  const pathOnProfile = pathname === "/profile/me";
  const pathOnHome =
    pathname.startsWith("/") &&
    !pathOnMessage &&
    !pathOnProfile &&
    !pathOnQuote;
  const blogUrl = "https://blog.ceedow.world/actualites";

  return (
    <div
      className={`${
        isMobileXs ? "py-3" : "py-1"
      } fixed flex items-center justify-between mt-5 shadow sm:invisible sm:hidden lg:hidden z-50 bg-white px-2 sm:p-0 border-t border-gray-300 md:fixed lg:fixed left-0 w-full bottom-0`}
    >
      <Link
        href={"/"}
        className={`${
          pathOnHome && "text-primary"
        } w-1/6 p-1 h-full flex flex-col items-center justify-center`}
      >
        <IoMdHome className="stroke-[1.6]" size={25} />
        {!isMobileXs && (
          <p
            className={`${pathOnHome ? "font-medium" : "font-normal"} text-xs`}
          >
            {getText({ id: "home" })}
          </p>
        )}
      </Link>
      <div
        className={`${
          openModalSearch && "text-primary"
        } w-1/6 p-1 h-full flex flex-col items-center cursor-pointer justify-center`}
        onClick={() => setOpenModalSearch(true)}
      >
        <Search className="black stroke-[1.55]" size={25} />
        {!isMobileXs && (
          <p
            className={`${
              openModalSearch ? "font-medium" : "font-normal"
            } text-xs`}
          >
            {getText({ id: "searchSidebar" })}
          </p>
        )}
      </div>
      <Link
        href={"/quote"}
        className={`${
          pathOnQuote && "text-primary"
        } w-1/6 p-1 h-full flex flex-col items-center justify-center`}
      >
        <CirclePlus className="black stroke-[1.55]" size={25} />
        {!isMobileXs && (
          <p
            className={`${pathOnQuote ? "font-medium" : "font-normal"} text-xs`}
          >
            {getText({ id: "quote" })}
          </p>
        )}
      </Link>
      <Link
        href={"/inbox"}
        className={`${
          pathOnMessage && "text-primary"
        } w-1/6 p-1 h-full flex flex-col items-center justify-center`}
      >
        <MessageCircle className="stroke-[1.55]" size={25} />
        {!isMobileXs && (
          <p
            className={`${pathOnMessage ? "font-medium" : "font-normal"} text-xs`}
          >
            {getText({ id: "messages" })}
          </p>
        )}
      </Link>
      <Link
        href={blogUrl}
        target="_blank"
        rel="noopener noreferrer"
        className={`w-1/6 p-1 h-full flex flex-col items-center justify-center`}
      >
        <Rss className="stroke-[1.55]" size={25} />
        {!isMobileXs && (
          <p
            className={`${"font-normal"} text-xs`}
          >
            Blog
          </p>
        )}
      </Link>
      <Link
        href={"/profile/me"}
        className={`${
          pathOnProfile && "text-primary"
        } w-1/6 p-1 h-full flex flex-col items-center justify-center`}
      >
        <User2 className="black stroke-[1.55]" size={25} />
        {!isMobileXs && (
          <p
            className={`${pathOnProfile ? "font-medium" : "font-normal"} text-xs`}
          >
            {getText({ id: "profile" })}
          </p>
        )}
      </Link>

      <ModalSearch
        openModalSearch={openModalSearch}
        setOpenModalSearch={setOpenModalSearch}
      />
    </div>
  );
};

export default BottomNav;
